"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_H1
 * @param {object} fields
 * @returns
 */
const titleNormalizer = (data) => {
    try {
        const res = {};
        const { fields } = data;
        const { title, titleH1, subTitle } = fields;
        if (title) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: title });
        }
        else if (titleH1) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: titleH1 });
        }
        if (subTitle) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: subTitle });
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = titleNormalizer;
//# sourceMappingURL=index.js.map